import { List, Map } from 'immutable';

import * as types from './types';
import { types as teamsTypes } from './../../ducks/teams';
import { STATUS_ACTIVE } from './../team-management/constants';
import { types as activityTypes, constants as activityConstants, utils } from './../activity';

const initialState = Map({
  activity: [],
  defaultTeamUsers: List(),
  defaultTeamSelectedUsers: List(),
  loading: true,
  // Filters for users - members of the team. Results & pagination in Users reducer for now (TODO)
  selectedFilters: Map({
    phrase: '',
    roles: List(),
    status: List([STATUS_ACTIVE]),
    teams: List(),
  }),
  team: null,
});

const teamDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIAL_DATA.REQUEST:
      return state.set('loading', true);
    case types.INITIAL_DATA.SUCCESS:
      return state.set('loading', false);
    case types.TEAM_GET.SUCCESS:
    case teamsTypes.TEAM_PATCH.SUCCESS:
      return state.set('team', payload);
    case activityTypes.GET_TEAMS_ACTIVITY.SUCCESS: {
      const team = state.get('team');
      if (!team) return state;
      return state.withMutations((mutable) => {
        Object
          .entries(payload)
          .forEach(([teamId, value]) => {
            if (team.id !== teamId) {
              return;
            }

            const data = utils.serializeMultiActivityData(value,
              activityConstants.CHARTS_DATA_PERIOD,
              activityConstants.CHARTS_NUMBER_OF_PERIODS,
            );

            mutable.set('activity', data);
          });
      });
    }
    case types.TOGGLE_FILTER:
      return state.setIn(['selectedFilters', payload.label], payload.value);
    case types.CLEAR_FILTERS:
      return state.set('selectedFilters', initialState.get('selectedFilters'));
    case types.DEFAULT_TEAM_USERS_GET.SUCCESS:
      return state.set('defaultTeamUsers', List(payload.results));
    case types.TOGGLE_DEFAULT_TEAM_USER: {
      const selectionList = state.get('defaultTeamSelectedUsers');
      const index = selectionList.indexOf(payload);
      const currentSelection = index === -1 ?
        selectionList.push(payload) :
        selectionList.delete(index);
      return state.set('defaultTeamSelectedUsers', currentSelection);
    }
    case types.MOVED_SELECTED_USERS_TO_TEAM:
      return state.set('defaultTeamSelectedUsers', initialState.get('defaultTeamSelectedUsers'));
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default teamDetailsReducer;
